<template>
  <div>
    <transition @enter="scaleUp" appear>
      <div class="md-layout md-gutter md-alignment-top-center" v-if="!loading">
        <div class="md-layout-item" style="max-width: 768px">
          <md-card class="card-title md-elevation-1" v-if="showBeginCard()">
            <md-card-header>
              <span class="md-title">{{ exam.name }}</span>
            </md-card-header>
            <md-card-content>
              <md-divider style="margin: 0px 0px 15px 0px"></md-divider>
              <span class="md-subheading">{{ exam.description }}</span>
              <md-list>
                <md-list-item style="border-left: 5px solid orange"
                  >{{ model.questionCount }} questions</md-list-item
                >
              </md-list>
            </md-card-content>
            <md-card-actions>
              <md-button
                class="md-raised md-primary"
                :to="examActionButtonUrl()"
                >Begin Exam</md-button
              >
            </md-card-actions>
          </md-card>
          <md-card class="card-title md-elevation-1" v-if="showContinueCard()">
            <md-card-header>
              <span class="md-title">{{ exam.name }}</span>
            </md-card-header>
            <md-card-content>
              <md-divider style="margin: 0px 0px 15px 0px"></md-divider>
              <span class="md-subheading">{{ exam.description }}</span>
              <md-list>
                <md-list-item style="border-left: 5px solid green"
                  >{{ model.answeredCount }} answered</md-list-item
                >
                <md-list-item style="border-left: 5px solid orange"
                  >{{ model.unansweredCount }} unanswered</md-list-item
                >
              </md-list>
            </md-card-content>
            <md-card-actions>
              <md-button
                class="md-raised md-primary"
                :to="examActionButtonUrl()"
                >Continue Exam</md-button
              >
            </md-card-actions>
          </md-card>
          <md-card class="card-title md-elevation-1" v-if="showTurnInCard()">
            <md-card-header>
              <span class="md-title">{{ exam.name }}</span>
            </md-card-header>
            <md-card-content>
              <md-divider style="margin: 0px 0px 15px 0px"></md-divider>
              <span class="md-subheading">{{ exam.description }}</span>
              <md-list>
                <md-list-item style="border-left: 5px solid green"
                  >{{ model.answeredCount }} answered</md-list-item
                >
                <md-list-item style="border-left: 5px solid orange"
                  >{{ model.unansweredCount }} unanswered</md-list-item
                >
              </md-list>
            </md-card-content>
            <md-card-actions>
              <md-button class="md-raised md-accent" @click="turnIn"
                >Turn In</md-button
              >
              <md-button
                class="md-raised md-primary"
                :to="examActionButtonUrl()"
                >Review Exam</md-button
              >
            </md-card-actions>
          </md-card>
          <md-card class="card-title md-elevation-1" v-if="showSubmitted()">
            <md-card-header>
              <span class="md-title">{{ exam.name }}</span>
            </md-card-header>
            <md-card-content>
              <md-divider style="margin: 0px 0px 15px 0px"></md-divider>
              <span class="md-subheading">{{ exam.description }}</span>
              <md-list>
                <md-list-item style="border-left: 5px solid green"
                  >{{ model.answeredCount }} answered</md-list-item
                >
                <md-list-item style="border-left: 5px solid orange"
                  >{{ model.unansweredCount }} unanswered</md-list-item
                >
              </md-list>
            </md-card-content>
            <md-card-actions>
            </md-card-actions>
          </md-card>
          <md-card class="card-title md-elevation-1" v-if="showReviewCard()">
            <md-card-header>
              <span class="md-title">{{ exam.name }}</span>
            </md-card-header>
            <md-card-content>
              <md-divider style="margin: 0px 0px 15px 0px"></md-divider>
              <span class="md-subheading">{{ exam.description }}</span>
              <md-list>
                <md-list-item style="border-left: 5px solid green"
                  >{{ model.correctCount }} correct</md-list-item
                >
                <md-list-item style="border-left: 5px solid orange"
                  >{{ model.incorrectCount }} incorrect</md-list-item
                >
              </md-list>
              <md-list>
                <md-list-item
                  ><span class="md-subheading"
                    >You scored {{ model.grade }}% on this exam.</span
                  ></md-list-item
                >
                <md-list-item
                  ><span class="md-subheading"
                    >You submitted your exam on
                    {{ formatDate(model.submittedOn) }} local time.</span
                  ></md-list-item
                >
              </md-list>
            </md-card-content>
            <md-card-actions>
              <md-button
                class="md-raised md-primary"
                :to="{ name: 'review-exam', params: { id: this.id } }"
                >Review Answers</md-button
              >
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { gsap } from "gsap";
import { mapState } from "vuex";
import { parseISO, formatDistance, format } from "date-fns";

export default {
  name: "ViewAssignment",
  data: () => ({
    id: 0,
      loading: false,
    term: '',
    model: {
      name: " ",
      dateDue: null,
      instructions: " ",
      examId: -1,
      state: " ",
      grade: 0,
      submittedOn: new Date().toString(),
      dateDue: new Date().toString(),
    },
    exam: {
      id: -1,
      name: " ",
      description: " ",
    },
  }),
  methods: {
    examActionButtonUrl() {
      if (this.model.state == 'Graded')
        return { name: "review-exam", params: { id: this.id } };
      else return { name: "view-exam", params: { id: this.id } };
    },
    examActionButtonText() {
      if (this.model.state == "Incomplete") return "Complete Exam";
      if (this.model.state == "Completed") return "Complete Exam";
      if (this.model.state == "Submitted") return "Review Exam";
      if (this.model.state == "Graded") return "Review Answers";
    },
    showBeginCard() {
      return this.model.state == "Incomplete" && this.model.answeredCount == 0;
    },
    showContinueCard() {
      return this.model.state == "Incomplete" && this.model.answeredCount > 0;
    },
    showTurnInCard() {
      return this.model.state == "Completed";
    },
    showReviewCard() {
      return this.model.state == "Graded";
    },
    showSubmitted() {
        return this.model.state == 'Submitted';
    },
    async turnIn() {
      await axios.put(`api/student-work/${this.id}/turn-in`);

      this.$router.push({ name: "classwork" });
    },
    formatDate(date) {
      return format(parseISO(date), "MM-dd-yyyy 'at' p");
    },
    formatDateDistance(date) {
      return formatDistance(parseISO(date), new Date());
    },
    async loadAssignment() {
      const response = await axios.get(`api/student-work/${this.id}/summary`);

      this.model = response.data;
    },
    async loadExamSummary() {
      const response = await axios.get(
        `api/exams/${this.model.examId}/summary`
      );

      this.exam = response.data;
    },
    scaleUp(element, done) {
      gsap.fromTo(
        element,
        {
          scale: 0.95,
          opacity: 0,
          transformOrigin: "center",
        },
        {
          scale: 1,
          opacity: 1,
          duration: 0.3,
          ease: "power3.inOut",
          onComplete: done,
        }
      );
    },
  },
  computed: mapState({
    role: (state) => state.role,
  }),
  async created() {
    this.loading = true;
    this.id = this.$route.params.id;
    this.term = this.$route.params.tid;

    await this.loadAssignment();
    await this.loadExamSummary();
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.linegraph {
  height: 5px;
}

.md-toolbar {
  background-color: var(--md-theme-default-background);
}

.card-title {
  border-left: 10px solid rgb(103, 58, 183);
}

.md-card {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  margin: 25px 0px 0px 0px;
  padding: 15px;
}

.text-justify {
  text-align: justify;
}

.text-indent {
  text-indent: 2em;
}

.newline {
  white-space: pre-wrap;
}

.no-margin {
  margin: 0px;
}
</style>
